import { MessageSquareHeart, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Modal } from '@/shared/components/modal'

import { useWelcomeStore } from '../store/welcomeStore'

/**
 * Modal de bienvenida / petición de feedback. Comunica que la web es nueva e
 * invita a dar feedback / reportar errores. Se abre en cada inicio de sesión
 * (ver {@link useWelcomeStore}); cualquier cierre lo oculta hasta el próximo
 * login.
 *
 * Se monta en {@code App.tsx} a nivel raíz. El CTA usa {@code <a href>} (full
 * reload a /contact, aceptable). La a11y (ESC, focus-trap, scroll-lock) la
 * provee el `<Modal>` base.
 */
export function WelcomeModal() {
  const { t } = useTranslation()
  const open = useWelcomeStore((s) => s.open)
  const close = useWelcomeStore((s) => s.close)

  if (!open) return null

  return (
    <Modal onClose={close} labelledBy="welcome-modal-title">
      <button
        type="button"
        aria-label={t('common.close')}
        onClick={close}
        className="absolute right-3 top-3 rounded-full p-1 text-muted-foreground hover:bg-black/5"
      >
        <X size={18} aria-hidden="true" />
      </button>
      <div className="mb-4 flex items-start gap-3">
        <span className="chip flex size-10 shrink-0 items-center justify-center rounded-md bg-yellow text-foreground">
          <MessageSquareHeart size={20} strokeWidth={2.5} aria-hidden="true" />
        </span>
        <h3 id="welcome-modal-title" className="font-display text-xl font-black leading-tight">
          {t('welcome.modal.title')}
        </h3>
      </div>
      <p className="mb-3 text-sm font-medium leading-relaxed text-foreground">
        {t('welcome.modal.body')}
      </p>
      <p className="mb-3 text-sm font-medium leading-relaxed text-foreground">
        {t('welcome.modal.invite')}
      </p>
      <p className="mb-5 text-sm font-bold leading-relaxed text-foreground">
        {t('welcome.modal.closing')}
      </p>
      <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={close}
          className="brutal-sm brutal-press order-2 inline-flex items-center justify-center rounded-lg bg-background-alt px-4 py-2 font-display text-sm font-bold text-foreground sm:order-1"
        >
          {t('welcome.modal.dismiss')}
        </button>
        <a
          href="/contact"
          onClick={close}
          className="brutal-sm brutal-press order-1 inline-flex items-center justify-center rounded-lg bg-yellow px-4 py-2 font-display text-sm font-bold text-foreground sm:order-2"
        >
          {t('welcome.modal.cta')}
        </a>
      </div>
    </Modal>
  )
}
